import { CallState } from "@b2bportal/core-types";
import { handleAsyncThunk } from "@b2bportal/core-utilities";
import type { ShopResponse } from "@b2bportal/ground-api";
import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import { initialCarShopState } from "./initialState";
import { fetchCarsShop } from "./thunk";
import type { VehicleAvailabilityWithSupplier } from "~core-cars/store";

export const carShopSlice = createSlice({
  name: "carShop",
  initialState: initialCarShopState,
  reducers: {
    setSelectedVehicle: (
      state,
      action: PayloadAction<VehicleAvailabilityWithSupplier>
    ) => {
      state.selectedVehicle = action.payload;
    },
    // For packages
    setShopResponseFromPackages: (
      state,
      action: PayloadAction<ShopResponse>
    ) => {
      state.response = {
        state: CallState.Success,
        data: action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    handleAsyncThunk(builder, fetchCarsShop, (state, resource) => {
      state.response = resource;
    });
  },
});

export const CarsShopActions = carShopSlice.actions;

export default carShopSlice.reducer;
